import React from "react";

import StatCard from "./StatCard";
import type { CategoryMeta, ModuleItem, StatsRecord } from "./types";

type Props = {
  meta: CategoryMeta;
  modules: ModuleItem[];
  stats: StatsRecord | null | undefined;
  onCardClick?: (m: ModuleItem) => void;
};

const DashboardSection: React.FC<Props> = ({
  meta,
  modules,
  stats,
  onCardClick,
}) => {
  if (modules.length === 0) return null;

  return (
    <section aria-label={meta.title}>
      <header className="mb-4 flex items-end justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2.5">
            <span
              aria-hidden
              className="h-4 w-[3px] rounded-full bg-brand"
            />
            <h3 className="truncate text-[16px] font-semibold tracking-tight text-gray-900">
              {meta.title}
            </h3>
            <span className="inline-flex h-5 min-w-[1.5rem] items-center justify-center rounded-full bg-gray-100 px-1.5 text-[10.5px] font-semibold tabular-nums text-gray-600">
              {modules.length}
            </span>
          </div>
          <p className="mt-1 truncate pl-[14px] text-[12px] text-gray-500">
            {meta.hint}
          </p>
        </div>
      </header>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
        {modules.map((module) => (
          <StatCard
            key={module.name}
            module={module}
            stats={stats}
            onClick={onCardClick}
          />
        ))}
      </div>
    </section>
  );
};

export default DashboardSection;
